// extracted by mini-css-extract-plugin
export default {"polyCanvasDiv":"PolyCanvas_polyCanvasDiv__WoV2Q","polyCanvasHiddenDiv":"PolyCanvas_polyCanvasHiddenDiv__4y1JX"};